import React from "react";
import { TableCell } from "@mui/material";

const TruncatedTableCell = ({
  children,
  title,
  className = "",
  textClassName = "",
  style = {},
  cellProps = {},
  maxChars = 22,
}) => {
  const rawValue = children ?? "N/A";
  const rawText =
    typeof rawValue === "string" || typeof rawValue === "number"
      ? String(rawValue)
      : null;
  const displayText =
    rawText && rawText.length > maxChars ? `${rawText.slice(0, maxChars)}...` : rawText || rawValue;
  const resolvedTitle = title ?? rawText ?? undefined;

  return (
    <TableCell className={className} style={style} title={resolvedTitle} {...cellProps}>
      <span className={`block w-full truncate ${textClassName}`.trim()}>{displayText}</span>
    </TableCell>
  );
};

export default TruncatedTableCell;
